import React from 'react';

export const ValueTextRenderer = ({
                             value,
                             valueClassName,
                           }) => {
  if (!value) return null;
  if (Array.isArray(value)) {
    return value && value.length > 0 && (
      <div className={valueClassName}>
        {value.map(val => val.label).join(', ')}
      </div>
    );
  }
  return value && (
    <div className={valueClassName}>
      {value.label}
    </div>
  );
};
